import { Logo } from "@/components/timeclock/Logo";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import type { ReactNode } from "react";

type SubpageHeaderProps = {
  /** Titre pour l’accessibilité uniquement (lecteurs d’écran). */
  pageTitle: string;
  /** Zone droite (ex. sélecteur de date) — laisse vide si inutile. */
  right?: ReactNode;
};

/**
 * 
 * @param pageTitle - Titre de la page
 * @param right - Zone droite (ex. sélecteur de date) — laisse vide si inutile.
 * @returns Le header de la page
 */
export function SubpageHeader({ pageTitle, right }: SubpageHeaderProps) {
  return (
    <header className="shrink-0 bg-card border-b border-border z-10 grid grid-cols-[1fr_auto_1fr] items-center gap-2 px-4 py-2.5">
      <div className="justify-self-start">
        <Link to="/home">
          <Button
            variant="outline"
            type="button"
            className="gap-1.5 rounded-full border-primary/30 bg-white px-3 py-1.5 text-sm font-medium text-primary shadow-sm transition-shadow hover:bg-primary/5 hover:shadow-md"
            aria-label="Retour à l’accueil"
          >
            <ArrowLeft className="h-4 w-4 shrink-0" />
            Retour
          </Button>
        </Link>
      </div>
      <div className="justify-self-center min-w-0">
        <span className="sr-only">{pageTitle}</span>
        <Logo />
      </div>
      <div className="justify-self-end flex min-h-10 items-center justify-end min-w-0">
        {right}
      </div>
    </header>
  );
}
